<template>
  <div class="warn">
    <div class="warn_content">
      <div class="warn_text" v-html="highlightHtml(list.title, list.keywords)">
      </div>
      <div class="warn_btn" @click="copyText">
        <i class="iconfont icon-fuzhi"></i>
        <span>复制</span>
      </div>
    </div>
    <ul class="warn_info">
      <li>
        <span class="warn_info_name">时间:</span><span class="warn_info_value">
          {{ moment(list.issueTime).format('YYYY-MM-DD HH: mm: ss') }}</span>
      <li>
        <span class="warn_info_name">来源:</span><span class="warn_info_value">{{ list.source }}</span>
      </li>
      <li>
        <span class="warn_info_name">作者:</span><span class="warn_info_value">{{ list.userName }}</span>
      </li>
      <li @click="goSouss()">
        <span class="warn_info_name">连接:</span>
        <div class="warn_info_value" style="color: #5cbbe1;">{{ list.sourceUrl }}</div>
      </li>
      <li>
        <span class="warn_info_name">行业:</span><span class="warn_info_value">{{ list.place }}</span>
      </li>
      <li>
        <span class="warn_info_name">涉及词:</span><span class="warn_info_value">
          <van-tag class="borFrame_content_box_tag" v-for="( item, index ) in  list.keywords " :key="index">{{
            item }}</van-tag>
        </span>
      </li>
      <!-- <li>
        <span class="warn_info_name">互动数:</span><span class="warn_info_value">1000</span>
      </li>
      <li>
        <span class="warn_info_name">粉丝数:</span><span class="warn_info_value">1000</span>
      </li>
      <li>
        <span class="warn_info_name">阅读数:</span><span class="warn_info_value">1000</span>
      </li> -->
      <li>
        <span class="warn_info_name">相似文章数:</span><span class="warn_info_value">{{ num }}</span>
      </li>
      </li>
      <li class="warn_info_btn">
        <van-button :color="'#7d809d'" @click="goSouss">查看原文</van-button>
        <van-button :color="'#5bbce0'" @click="copyTextAll">全部复制</van-button>
      </li>
    </ul>
    <div class="warn_footer">
      <div class="warn_footer_title">
        【摘要】
      </div>
      <van-divider :style="{ borderColor: '#ccc', }" dashed />
      <!-- 合并两个关键词数组 -->
      <div v-if="list.keywords" class="warn_footer_content" v-html="highlightHtml(list.content, list.keywords)">
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { similarArticle, getArticleDetail } from '@/api/index';
import { geturl } from '@/utils/index';
export default {
  data() {
    return {
      list: {},
      num: 0,
      keyword: []
    }
  },
  mounted() {
    // 获取浏览器地址参数
    let params = geturl()
    console.log(params);
    if (params && params.type) {
      this.getList(params.acquaintance);
      this.getArticleDetail(params.uuid);
      this.keyword = params.keyword.split(',');
    } else {
      this.list = JSON.parse(this.$route.query.item);
      if (this.list.acquaintance) {
        this.getList(this.list.acquaintance);
      }
    }

  },
  methods: {
    moment,
    copyText() {
      const input = document.createElement('input');
      input.value = this.list.title;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$toast('复制成功');
    },
    copyTextAll() {
      const textarea = document.createElement('textarea');
      const warn_info = document.querySelector('.warn_info');
      const liArr = warn_info.querySelectorAll('li:not(:last-child)');
      let content = '';
      liArr.forEach(li => {
        const name = li.querySelector('.warn_info_name').textContent;
        const value = li.querySelector('.warn_info_value').textContent;
        console.log(name, value);
        content += `${name} ${value}\n`;
      });
      textarea.value = content;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      this.$toast('复制成功');
    },

    goSouss() {
      window.open(this.list.sourceUrl);
    },
    getList(id) {
      similarArticle({ acquaintance: id }).then(res => {
        this.num = res
      })
    },
    // 高亮关键词
    highlightHtml(results, keyWords, isTitle) {
      console.log(keyWords);
      if (!results) return results
      let str = results.replace(/<[^>]+>/g, '')

      let content = str
      keyWords = keyWords || []
      // 关键字*号处理
      keyWords.reduce((pre, next) => pre.concat(next.split('*')), []).map((keyitem) => {
        if (keyitem) {
          // 匹配关键字正则
          const replaceReg = new RegExp(keyitem, 'g')
          // 高亮替换v-html值
          const replaceString = `<span style="color: red; font-size: ${isTitle ? 'auto' : '18px'}">${keyitem}</span>`
          content = content.replace(replaceReg, replaceString)
        }
      })
      return content
    },
    // 获取文章详情
    getArticleDetail(val) {
      getArticleDetail({ uuid: val }).then(res => {
        this.list = res;
        if (this.list.keywords) {
          this.list.keywords = this.list.keywords.concat(this.keyword)
        } else {
          this.list.keywords = this.keyword
        }
      }
      )
    }
  }
}
</script>
 
<style lang = "less" scoped>
.warn {
  background: #f5f5f5;
  min-height: 98vh;

  &_content {
    display: flex;
    background: #fff;
    padding: .1rem;
  }

  &_text {
    width: 85%;
    font-size: .16rem;
    font-weight: bold;
  }

  &_btn {
    width: 13%;
    margin-left: 2%;
  }

  &_info {
    padding: .14rem;
    background: #fff;

    &_name {
      font-size: .14rem;
      color: #999;
      display: inline-block;
      vertical-align: top;
    }

    &_value {
      font-size: .16rem;
      display: inline-block;
      width: 70%;
      word-break: break-all;
      margin-left: .1rem;
    }

    &_btn {
      margin-top: .1rem;
      display: flex;
      justify-content: space-around;
    }

    li {
      padding: .1rem 0;
    }
  }

  &_footer {
    background: #fff;
    margin-top: .1rem;

    &_title {
      font-size: .16rem;
      color: #5ec0d3;
      margin-left: .3rem;
      padding: .1rem;
    }

    &_content {
      padding: .1rem .2rem;
    }
  }

  .borFrame_content_box_tag {
    margin-right: .1rem;
    // 边框阴影
    box-shadow: 0 0 0 1px #ccc;
    font-size: .14rem;
  }
}
</style>